import { render, staticRenderFns } from "./spcmCounsellorAdd.vue?vue&type=template&id=1c3af6cc"
import script from "./spcmCounsellorAdd.vue?vue&type=script&lang=js"
export * from "./spcmCounsellorAdd.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports